import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UtilsService } from '../utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { merge, take } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class LiteralService {
  private readonly translationsChanged: Signal<unknown>;

  constructor(
    private utilService: UtilsService,
    private translateService: TranslateService,
    private titleService: Title
  ) {
    this.translationsChanged = toSignal(
      merge(
        this.translateService.onLangChange,
        this.translateService.onTranslationChange,
        this.translateService.onFallbackLangChange,
      ),
    );
  }

  // Templates call this on every change detection cycle, often before the key is known.
  // ngx-translate throws on an empty key, and a throw here aborts the whole view render
  public get(key: string, capitalized: boolean = false, args?: any): string {
    this.translationsChanged();
    if (!key) return '';
    const res = this.translateService.instant(key, args);
    return capitalized ? this.utilService.capitalize(res) : res;
  }

  public currentLanguage(): string | undefined {
    this.translationsChanged();
    return this.translateService.getCurrentLang() ?? this.translateService.getFallbackLang() ?? undefined;
  }

  public setTitle(key: string, suffix?: string): any {
    this.translateService.get(key).pipe(take(1)).subscribe((res) => {
      this.titleService.setTitle(this.utilService.capitalize(res) + suffix);
    })
  }
}
